import React from 'react';
import styled from 'styled-components';
import {device} from '../../assets/device'
import EventMonthFilter from './EventMonthFilter';
import EventCategoryFilter from './EventCategoryFilter';
import EventMonthList from './EventMonthList';
import ShoppingCartButton from '../ShoppingCartButton';

export const FilterableEventMonthListStyles = {
	FilterBarContainer: styled.div`
      flex-direction: column;
      width: 100%;

      div:last-child {
        margin: 0;
      }
      //noinspection ALL
      @media ${device.tablet} {
        flex-direction: row;
        width: auto;
        justify-content: space-between;
        flex-grow: 1;
        flex-basis: 100%;
      }

      max-width: 580px;
      display: flex;
      font-size: .9em;

      & > div {
        margin: 0 0 1em 0;
        //noinspection ALL
        @media ${device.tablet} {
          width: 48%;
          margin: 0
        }
      }
	`,
	HeaderBar: styled.div`
      display: flex;
      width: 100%;
      justify-content: space-between;
      margin-bottom: 1em;
	`,
	ShoppingCartButton: styled.div`
      display: flex;
      justify-content: flex-end;
      width: calc(13.5rem + 6px);

	`,
};
const S = FilterableEventMonthListStyles;

class FilterableEventMonthList extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			monthsFiltered: props.events,
			categoryFiltered: props.events,
			events: props.events,
		};
		this.updateMonthFilteredEvents = this.updateMonthFilteredEvents.bind(this);
		this.updateCategoryFilteredEvents = this.updateCategoryFilteredEvents.bind(this);
	}

	componentDidReceiveProps(newprops) {
		this.setState({
			monthsFiltered: newprops.events,
			categoryFiltered: newprops.events,
			events: newprops.events
		});
	}

	static intersec(array1, array2) {
		return array1.filter(value => array2.indexOf(value) !== -1);
	}

	updateMonthFilteredEvents(events) {
		this.setState({
			monthsFiltered: events,
			events: FilterableEventMonthList.intersec(this.state.categoryFiltered, events),
		});
	}

	updateCategoryFilteredEvents(events) {
		this.setState({
			categoryFiltered: events,
			events: FilterableEventMonthList.intersec(this.state.monthsFiltered, events),
		});
	}


	render() {
		return (
			<div>
				<S.HeaderBar>
					<S.FilterBarContainer>
						<EventCategoryFilter
							events={this.props.events}
							dropdownEvents={this.props.events}
							updateEvents={this.updateCategoryFilteredEvents}
						/>
						<EventMonthFilter
							events={this.props.events}
							dropdownEvents={this.props.events}
							updateEvents={this.updateMonthFilteredEvents}
						/>
					</S.FilterBarContainer>
					<S.ShoppingCartButton>
						<ShoppingCartButton/>
					</S.ShoppingCartButton>
				</S.HeaderBar>
				<EventMonthList events={this.state.events}/>
			</div>);
	}
}

export default FilterableEventMonthList;
